<template>
  <div class="page_rosterEmpDtl">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>面试入职流程</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/empRosterPerson', query: { active: '花名册列表' } }">花名册列表</el-breadcrumb-item>
          <el-breadcrumb-item>详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">

        <el-tabs v-model="activeName" @tab-click="changeTab" class="s_tabs_box">
            <el-tab-pane label="详情" name="0"></el-tab-pane>
            <el-tab-pane label="修改" name="1"></el-tab-pane>
          </el-tabs>
        <div class="dtlBox">
          <!-- 项目信息 -->
          <div class="Reititle"><span class="titleLine">|</span> 项目信息
            <el-button type="text" size="small" @click="getMore('1')">
              <i :class="!showMore1 ? 'el-icon-caret-bottom' : 'el-icon-caret-top'" style="font-size:14px;"></i>
              {{ !showMore1 ? '展开' : '收起' }}</el-button>
          </div>
          <div class="dtlItem" v-if="showMore1">
            <el-form :inline="true" label-width="125px">
              <el-form-item label="项目名称:">{{ proInfo.StrObjName }}</el-form-item>
              <el-form-item label="服务中心:">{{ proInfo.StrSrvCent }}</el-form-item>
              <el-form-item label="项目类别:">{{ proInfo.StrProjectType }}</el-form-item>
              <el-form-item label="业绩归属部门:">{{ proInfo.StrObjInstName }}</el-form-item>
              <el-form-item label="负责客服:">{{ proInfo.StrUserName }}</el-form-item>
              <el-form-item label="部门:">{{ info.StrprojectName }}</el-form-item>
              <el-form-item label="岗位:">{{ info.StrJobInf }}</el-form-item>
              <el-form-item label="推送人:">{{ proInfo.name }}</el-form-item>
              <el-form-item label="候选人推荐日期:">{{ proInfo.name }}</el-form-item>
              <el-form-item label="推荐人备注:">{{ proInfo.name }}</el-form-item>
              <el-form-item label="招聘岗位类别:">{{ proInfo.name }}</el-form-item>
              <el-form-item label="招聘岗位:">{{ proInfo.name }}</el-form-item>
            </el-form>
          </div>

          <!-- 基本信息 -->
          <div class="Reititle"><span class="titleLine">|</span> 基本信息
            <el-button type="text" size="small" @click="getMore('2')">
              <i :class="!showMore2 ? 'el-icon-caret-bottom' : 'el-icon-caret-top'" style="font-size:14px;"></i>
              {{ !showMore2 ? '展开' : '收起' }}</el-button>
          </div>
          <div class="dtlItem" v-if="showMore2">
            <el-form :inline="true" label-width="125px">
              <el-form-item label="姓名:">{{ info.StrEmpName }}</el-form-item>
              <el-form-item label="身份证:">{{ info.StrIdCard }}</el-form-item>
              <el-form-item label="出生年月:">{{ birth }}</el-form-item>
              <el-form-item label="年龄:">{{ age }}</el-form-item>
              <el-form-item label="性别:">{{ sex }}</el-form-item>
              <el-form-item label="民族:">{{ info.StrNationClass }}</el-form-item>
              <el-form-item label="身份证到期时间:">{{ info.DtIcCareEdate }}</el-form-item>
              <el-form-item label="籍贯:">{{ info.StrNativePlace }}</el-form-item>
              <el-form-item label="在离职/状态:">{{ info.StrWorkState }}</el-form-item>
              <el-form-item label="联系方式:">{{ info.StrPhoneNum }}</el-form-item>
              <el-form-item label="参保种类:">{{ info.StrInsuranceType }}</el-form-item>
              <el-form-item label="参保日期:">{{ info.DtInsuranceDate }}</el-form-item>
              <div class="long">
                <el-form-item label="开票公司全称:">{{ info.StrBlCmp }}</el-form-item>
              </div>
              <el-form-item label="离职日期:">{{ info.DtDepartureDate }}</el-form-item>
              <el-form-item label="实际离职日期:">{{ info.DtRealDepartureDate }}</el-form-item>
              <el-form-item label="离职原因:">{{ info.OutCompanyReason }}</el-form-item>
              <el-form-item label="是否黑名单:">{{ info.StrBlacklist }}</el-form-item>
              <div class="long">
                <el-form-item label="黑名单原因:">{{ info.StrBlacklistReason }}</el-form-item>
              </div>
              <el-form-item label="临时工:">{{ info.StrOther }}</el-form-item>
              <el-form-item label="档案号:">{{ info.StrFileNo }}</el-form-item>
              <el-form-item label="用户之日:">{{ info.DtEntryBdate }}</el-form-item>
              <el-form-item label="司龄:">{{ info.CompanyAge }}</el-form-item>
              <el-form-item label="银行卡:">{{ info.StrBankCard }}</el-form-item>
              <el-form-item label="合同/协议:">{{ info.StrContractType }}</el-form-item>
              <el-form-item label="身份证正面:">{{ info.FrontCardIdUrl }}</el-form-item>
              <el-form-item label="身份证反面:">{{ info.VersoCardIdUrl }}</el-form-item>
            </el-form>
          </div>

          <!-- 详细信息 -->
          <div class="Reititle"><span class="titleLine">|</span> 详细信息
            <el-button type="text" size="small" @click="getMore('3')">
              <i :class="!showMore3 ? 'el-icon-caret-bottom' : 'el-icon-caret-top'" style="font-size:14px;"></i>
              {{ !showMore2 ? '展开' : '收起' }}</el-button>
          </div>
          <div class="dtlItem" v-if="showMore3">
            <el-form :inline="true" label-width="125px">
              <el-form-item label="婚姻状况:">{{ info.MarriageState }}</el-form-item>
              <el-form-item label="户粮:">{{ info.StrCityzenType }}</el-form-item>
              <el-form-item label="紧急联系人:">{{ info.StrContName }}</el-form-item>
              <el-form-item label="政治面貌:">{{ info.StrPolitical }}</el-form-item>
              <div class="long">
                <el-form-item label="现住地址:">{{ info.StrAddr }}</el-form-item>
              </div>
              <div class="long">
                <el-form-item label="户籍地址:">{{ info.StrNativeAddr }}</el-form-item>
              </div>
              <el-form-item label="银行:">{{ info.StrBankName }}</el-form-item>
              <el-form-item label="银行卡号:">{{ info.StrBankCard }}</el-form-item>
              <el-form-item label="体检类型:">{{ info.StrPetype }}</el-form-item>
              <el-form-item label="体检结果:">{{ info.StrPeres }}</el-form-item>
              <div class="long">
                <el-form-item label="最高学历学校名称:" label-width="150px">{{ info.SchoolName }}</el-form-item>
              </div>
              <el-form-item label="入学起始时间:">{{ info.InSchoolTime }}</el-form-item>
              <el-form-item label="入学结束时间:">{{ info.OutSchoolTime }}</el-form-item>
              <el-form-item label="工伤发生时间:">{{ info.DtInjuryBdate }}</el-form-item>
              <el-form-item label="伤残等级:">{{ info.StrDisabilityLevel }}</el-form-item>
              <el-form-item label="三期开始日期:">{{ info.ThreeBeginTime }}</el-form-item>
              <el-form-item label="三期结束日期:">{{ info.ThreeEndTime }}</el-form-item>
              <el-form-item label="备注:">{{ info.StrRemark }}</el-form-item>
              <!-- <el-form-item label="导入备注:">{{info.StrObjName}}</el-form-item> -->
            </el-form>
          </div>
          <div class="Reititle"><span class="titleLine">|</span> 合同信息
            <el-button type="text" size="small" @click="getMore('6')">
              <i :class="!showMore6 ? 'el-icon-caret-bottom' : 'el-icon-caret-top'" style="font-size:14px;"></i>
              {{ !showMore6 ? '展开' : '收起' }}</el-button>
          </div>
          <div class="dtlItem" v-if="showMore6">
            <el-table :data="ContractJson" border class="doc_table" style="width:100%;margin-bottom: 20px;">
              <el-table-column align="center" show-overflow-tooltip label="次数" prop="times" min-width="80">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="类型" prop="type" min-width="100">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="用工之日" prop="DtEntryBdate" min-width="100">
                <template slot-scope="{row}">{{ row.DtEntryBdate ? row.DtEntryBdate.split('T')[0] : '' }}</template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="合同开始时间" prop="DtContractBtime"
                min-width="100">
                <template slot-scope="{row}">{{ row.DtContractBtime ? row.DtContractBtime.split('T')[0] : ''
                  }}</template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="合同结束时间" prop="DtContractTime"
                min-width="100">
                <template slot-scope="{row}">{{ row.DtContractTime ? row.DtContractTime.split('T')[0] : '' }}</template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="试用期结束时间" prop="DtProbationEdate"
                min-width="100">
                <template slot-scope="{row}">{{ row.DtProbationEdate ? row.DtProbationEdate.split('T')[0] : ''
                  }}</template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="附件" prop="fileUrl" min-width="100">
              </el-table-column>
            </el-table>
          </div>

          <!-- 电子签信息 -->
          <div class="Reititle"><span class="titleLine">|</span> 电子签信息
            <el-button type="text" size="small" @click="getMore('4')">
              <i :class="!showMore4 ? 'el-icon-caret-bottom' : 'el-icon-caret-top'" style="font-size:14px;"></i>
              {{ !showMore4 ? '展开' : '收起' }}</el-button>
          </div>
          <div class="dtlItem" v-if="showMore4">
            <el-table :data="signInfo" border class="doc_table" style="width:100%">
              <el-table-column align="center" show-overflow-tooltip label="签约人" prop="Name" min-width="100"
                fixed="left">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="签约手机" prop="PhoneNum" min-width="110">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="项目" prop="ObjName" min-width="160">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="岗位" prop="JobName" min-width="100">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="身份份证号码" prop="StrIdCard" min-width="160">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="合同协议类型" prop="ProtocolType" min-width="120">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="签约主体" prop="ContractSubject" min-width="160">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="合同名称" prop="TempName" min-width="120">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="合同起始时间" prop="ContractStartTime"
                min-width="120">
                <template slot-scope="{row}">{{ row.ContractStartTime ? row.ContractStartTime.split('T')[0] : ''
                  }}</template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="合同结束时间" prop="ContractEndTime"
                min-width="120">
                <template slot-scope="{row}">{{ row.ContractEndTime ? row.ContractEndTime.split('T')[0] : ''
                  }}</template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="试用期起始时间" prop="TrialPeriodStartTime"
                min-width="120">
                <template slot-scope="{row}">{{ row.TrialPeriodStartTime ? row.TrialPeriodStartTime.split('T')[0] : ''
                  }}</template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="试用期结束时间" prop="TrialPeriodEndTime"
                min-width="120">
                <template slot-scope="{row}">{{ row.TrialPeriodEndTime ? row.TrialPeriodEndTime.split('T')[0] : ''
                  }}</template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="签约来源" prop="SourceContract" min-width="100">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="文化程度" prop="StrEduLvl" min-width="100">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="状态" prop="SignatureStatus" min-width="100">
              </el-table-column>
            </el-table>
          </div>

          <!-- 商保信息 -->
          <div class="Reititle"><span class="titleLine">|</span> 商保信息
            <el-button type="text" size="small" @click="getMore('5')">
              <i :class="!showMore5 ? 'el-icon-caret-bottom' : 'el-icon-caret-top'" style="font-size:14px;"></i>
              {{ !showMore5 ? '展开' : '收起' }}</el-button>
          </div>

          <!-- 备注 -->
          <div class="dtlItem" v-if="showMore5">
            <el-table :data="insureInfo" border class="doc_table" style="width:100%">
              <el-table-column align="center" show-overflow-tooltip label="姓名" prop="InsuredName" min-width="100"
                fixed="left">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="项目" prop="ProjectName" min-width="160">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="手机号" prop="InsuredPhone" min-width="100">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="险种" prop="InsuranceName" min-width="100">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="申请日期" prop="CreateTime" min-width="100">
                <template slot-scope="{row}">{{ row.CreateTime ? row.CreateTime.split('T')[0] : '' }}</template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="隶属公司" prop="ContractParty" min-width="160">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="岗位" prop="JobName" min-width="100">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="职业类别" prop="JobClasss" min-width="100">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="员工属性" prop="EmployeeAttribute"
                min-width="100">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="来源" prop="OperationalSource" min-width="100">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="保障开始" prop="CoverStartTime" min-width="100">
                <template slot-scope="{row}">{{ row.CoverStartTime ? row.CoverStartTime.split('T')[0] : '' }}</template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="保障结束" prop="CoverEndTime" min-width="100">
                <template slot-scope="{row}">{{ row.CoverEndTime ? row.CoverEndTime.split('T')[0] : '' }}</template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="状态" prop="Status" min-width="100">
              </el-table-column>
            </el-table>
          </div>
          <div class="Reititle"><span class="titleLine">|</span> 其他备注
            <el-button type="text" size="small" @click="getMore('7')">
              <i :class="!showMore7 ? 'el-icon-caret-bottom' : 'el-icon-caret-top'" style="font-size:14px;"></i>
              {{ !showMore7 ? '展开' : '收起' }}</el-button>
          </div>
          <div class="dtlItem" v-if="showMore7">
            <el-form :inline="true" label-width="125px">
              <el-form-item label="备注1:">{{ remarkInfo.备注1 }}</el-form-item>
              <el-form-item label="备注2:">{{ remarkInfo.备注2 }}</el-form-item>
              <el-form-item label="备注3:">{{ remarkInfo.备注3 }}</el-form-item>
              <el-form-item label="备注4:">{{ remarkInfo.备注4 }}</el-form-item>
              <el-form-item label="备注5:">{{ remarkInfo.备注5 }}</el-form-item>
              <el-form-item label="备注6:">{{ remarkInfo.备注6 }}</el-form-item>
              <el-form-item label="备注7:">{{ remarkInfo.备注7 }}</el-form-item>
              <el-form-item label="备注8:">{{ remarkInfo.备注8 }}</el-form-item>
              <el-form-item label="备注9:">{{ remarkInfo.备注9 }}</el-form-item>
              <el-form-item label="备注10:">{{ remarkInfo.备注10 }}</el-form-item>
              <el-form-item label="备注11:">{{ remarkInfo.备注11 }}</el-form-item>
              <el-form-item label="备注12:">{{ remarkInfo.备注12 }}</el-form-item>
              <el-form-item label="备注13:">{{ remarkInfo.备注13 }}</el-form-item>
              <el-form-item label="备注14:">{{ remarkInfo.备注14 }}</el-form-item>
              <el-form-item label="备注15:">{{ remarkInfo.备注15 }}</el-form-item>
              <el-form-item label="备注16:">{{ remarkInfo.备注16 }}</el-form-item>
              <el-form-item label="备注17:">{{ remarkInfo.备注17 }}</el-form-item>
              <el-form-item label="备注18:">{{ remarkInfo.备注18 }}</el-form-item>
              <el-form-item label="备注19:">{{ remarkInfo.备注19 }}</el-form-item>
              <el-form-item label="备注20:">{{ remarkInfo.备注20 }}</el-form-item>
            </el-form>
          </div>


          <div class="btn_box">
            <el-button type="success" @click="printHandel">打印</el-button>
            <el-button @click="backHandle">返 回</el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="打印" :visible.sync="showPrint" width="1030px">
      <div class="tabBox" id="printBox">
        <table width="100%" border="0" cellspacing="1" cellpadding="4" class="invoiceTable" align="center"
          style="border: 2px solid #000;">
          <tr>
            <td width="12%" class="font-center titfont">◆姓名</td>
            <td width="12%" class="font-center ">{{ info.StrEmpName }}</td>
            <td width="12%" class="font-center titfont">◆性别</td>
            <td width="12%" class="font-center "> {{ sex }}</td>
            <td width="12%" class="font-center titfont">◆民族</td>
            <td width="12%" class="font-center "> {{ info.StrNationClass }}</td>
            <td width="18%" colspan="2" rowspan="6">
              <div class="photoBox">
                <div>照</div>
                <div style="margin-top: 20px;">片</div>
              </div>
            </td>
          </tr>
          <tr>
            <td width="12%" class="font-center titfont">◆出生日期</td>
            <td width="12%" class="font-center ">{{ birth }}</td>
            <td width="12%" class="font-center titfont">◆籍贯</td>
            <td width="12%" class="font-center ">{{ info.StrNativePlace }}</td>
            <td width="12%" class="font-center titfont">◆学历</td>
            <td width="12%" class="font-center ">{{ info.StrEduLv }}</td>
          </tr>
          <tr>
            <td width="12%" class="font-center titfont">所学专业</td>
            <td width="12%" class="font-center "></td>
            <td class="font-center titfont" colspan="2">◆身份证号码</td>
            <td class="font-center " colspan="2">{{ info.StrIdCard }}</td>
          </tr>
          <tr>
            <td width="12%" class="font-center titfont">◆婚姻状况</td>
            <td width="12%" class="font-center ">{{ info.MarriageState }}</td>
            <td width="12%" class="font-center titfont">身高</td>
            <td width="12%" class="font-center "></td>
            <td width="12%" class="font-center titfont">是否近视/度数</td>
            <td width="12%" class="font-center "></td>
          </tr>
          <tr>
            <td width="12%" class="font-center titfont">体重</td>
            <td width="12%" class="font-center "></td>
            <td width="12%" class="font-center titfont">身体状态</td>
            <td width="12%" class="font-center "></td>
            <td width="12%" class="font-center titfont">有何资格证书</td>
            <td width="12%" class="font-center "></td>
          </tr>
          <tr>
            <td width="12%" class="font-center titfont">◆联系电话</td>
            <td width="12%" class="font-center ">{{ info.StrEmpName }}</td>
            <td width="12%" class="font-center titfont">QQ</td>
            <td width="12%" class="font-center "></td>
            <td width="12%" class="font-center titfont">常用电子邮件</td>
            <td width="12%" class="font-center "></td>
          </tr>
          <tr>
            <td class="font-center titfont">◆家庭电话</td>
            <td class="font-center " colspan="3"></td>
            <td class="font-center titfont" colspan="2">◆紧急联系人姓名与电话</td>
            <td class="font-center " colspan="2">{{ info.StrContName + '/' + info.StrContTel }}</td>
          </tr>
          <tr>
            <td class="font-center titfont">◆现居通讯地址</td>
            <td class="font-center " colspan="3">{{ info.StrAddr }}</td>
            <td class="font-center titfont" colspan="2">◆身份证地址</td>
            <td class="font-center " colspan="2"></td>
          </tr>
          <tr>
            <td class="font-center titfont">计算机水平</td>
            <td class="font-center"></td>
            <td class="font-center titfont" colspan="2">◆户粮关系</td>
            <td class="font-center" colspan="4">
              <div class="checkBox flex">
                <el-checkbox v-model="checked">农村</el-checkbox>
                <el-checkbox v-model="checked2">城镇</el-checkbox>
              </div>
            </td>
          </tr>
          <tr>
            <td class="font-center titfont">外语类别及水平</td>
            <td class="font-center" colspan="3"></td>
            <td class="font-center titfont">◆政治面貌</td>
            <td class="font-center" colspan="3">
              <div class="checkBox flex">
                <el-checkbox-group v-model="checkList">
                  <el-checkbox label="党员"></el-checkbox>
                  <el-checkbox label="团员"></el-checkbox>
                  <el-checkbox label="群众"></el-checkbox>
                </el-checkbox-group>
              </div>
            </td>
          </tr>
          <tr>
            <td width="12%" class="font-center titfont">驾照及驾龄</td>
            <td width="12%" class="font-center "></td>
            <td width="12%" class="font-center titfont" colspan="2">是否要安排住宿</td>
            <td width="12%" class="font-center "></td>
            <td width="12%" class="font-center titfont">期望薪资</td>
            <td width="12%" class="font-center " colspan="2"></td>
          </tr>
          <tr>
            <td class="font-center titfont" colspan="8">教育经历</td>
          </tr>
          <tr>
            <td class="font-center titfont" colspan="2">起止时间</td>
            <td class="font-center titfont" colspan="2">学校（培训单位）名称</td>
            <td class="font-center titfont" colspan="2">专业</td>
            <td class="font-center titfont" colspan="2">备注</td>
          </tr>
          <tr>
            <td class="font-center" colspan="2"></td>
            <td class="font-center" colspan="2"></td>
            <td class="font-center" colspan="2"></td>
            <td class="font-center" colspan="2"></td>
          </tr>
          <tr>
            <td class="font-center" colspan="2"></td>
            <td class="font-center" colspan="2"></td>
            <td class="font-center" colspan="2"></td>
            <td class="font-center" colspan="2"></td>
          </tr>
          <tr>
            <td class="font-center" colspan="2"></td>
            <td class="font-center" colspan="2"></td>
            <td class="font-center" colspan="2"></td>
            <td class="font-center" colspan="2"></td>
          </tr>
          <tr>
            <td class="font-center titfont" colspan="8">工作及实习经历</td>
          </tr>
          <tr>
            <td class="font-center titfont">开始年月</td>
            <td class="font-center titfont">离开年月</td>
            <td class="font-center titfont" colspan="2">工作单位</td>
            <td class="font-center titfont" colspan="2">职务（岗位）</td>
            <td class="font-center titfont" colspan="2">离职原因</td>
          </tr>
          <tr>
            <td class="font-center"></td>
            <td class="font-center"></td>
            <td class="font-center" colspan="2"></td>
            <td class="font-center" colspan="2"></td>
            <td class="font-center" colspan="2"></td>
          </tr>
          <tr>
            <td class="font-center"></td>
            <td class="font-center"></td>
            <td class="font-center" colspan="2"></td>
            <td class="font-center" colspan="2"></td>
            <td class="font-center" colspan="2"></td>
          </tr>
          <tr>
            <td class="font-center"></td>
            <td class="font-center"></td>
            <td class="font-center" colspan="2"></td>
            <td class="font-center" colspan="2"></td>
            <td class="font-center" colspan="2"></td>
          </tr>
          <tr>
            <td class="font-center titfont" colspan="8">家庭成员</td>
          </tr>
          <tr>
            <td class="font-center titfont">称谓</td>
            <td class="font-center titfont">姓名</td>
            <td class="font-center titfont">出生年月</td>
            <td class="font-center titfont" colspan="2">工作单位</td>
            <td class="font-center titfont">职务（工种）</td>
            <td class="font-center titfont">联系电话</td>
          </tr>
          <tr v-for="item in 3" :key="item">
            <td class="font-center"></td>
            <td class="font-center"></td>
            <td class="font-center"></td>
            <td class="font-center" colspan="2"></td>
            <td class="font-center"></td>
            <td class="font-center"></td>
          </tr>
          <tr>
            <td colspan="8">
              <div class="ensure">我保证,本表格所填各项内容属实，如有虚假，本人愿意接受公司任何处罚以及承担相应的经济与法律责任。</div>
              <div class="signatureBox">
                <div>◆签名：</div>
                <div class="year" style="margin-left: 120px;">年</div>
                <div class="year">月</div>
                <div class="year">日</div>
              </div>
              <div class="signatureTips">
                注：请在填写前认真阅读背后特别说明，并签字确认。
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <div class="d1">
                工作人员意见
              </div>
              <div class="d2 flex sb">
                <div>签名：</div>
                <div class="flex">
                  <div class="year" style="margin-left: 120px;">年</div>
                  <div class="year">月</div>
                  <div class="year">日</div>
                </div>
              </div>
            </td>
            <td colspan="4">
              <div class="d1">
                客户单位意见
              </div>
              <div class="d2 flex sb">
                <div>签名：</div>
                <div class="flex">
                  <div class="year" style="margin-left: 120px;">年</div>
                  <div class="year">月</div>
                  <div class="year">日</div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPrint = false" size="small">取消</el-button>
        <el-button type="primary" @click="printClick('printBox', '')" size="small">确定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
import xz from "../../common";
import print from 'print-js';
export default {
  data() {
    return {
      roletype: localStorage.loginRoletype,
      empQuery: {
        strExcelPath: '',
        intExcelLine: ''
      },
      showPrint: false,
      info: {},
      proInfo: {},
      signInfo: [],
      ContractJson:[],
      insureInfo: [],
      insureListInfo: [],
      checked: false,
      checked2: false,
      checkList: [],
      age: '',
      sex: '',
      birth: '',
      showMore1: true,
      showMore2: false,
      showMore3: false,
      showMore4: false,
      showMore5: false,
      showMore6: false,
      showMore7: false,
      activeName:'0',
      remarkInfo:{}
    }
  },
  created() {
    if (this.$route.query.strExcelPath != undefined && this.$route.query.strExcelPath) {
      this.empQuery.strExcelPath = this.$route.query.strExcelPath;
      this.empQuery.intExcelLine = this.$route.query.intExcelLine;
      this.PersonInfo();
    }
  },
  methods: {
    changeTab(){
      if(this.activeName=='1'){
        this.$router.push({
          path:'/rosterEmpEdit',
          query:{
            strExcelPath: this.empQuery.strExcelPath,
            intExcelLine: this.empQuery.intExcelLine
          }
        })
      }
    },
    PersonInfo() {
      xz.PersonInfo(this.empQuery, this.roletype).then(res => {
        if (res.status == 'ok') {
          this.info = res.info;
          this.remarkInfo = JSON.parse(res.info.Json);
          this.proInfo = res.proInfo[0];
          this.signInfo = res.signInfo;
          this.insureInfo = res.insureInfo;
          this.getBirth(this.info.StrIdCard)
          if (res.info.StrCityzenType == '农') {
            this.checked = true;
          } else if (res.info.StrCityzenType == '居') {
            this.checked2 = true;
          }
          if (res.info.StrPolitical) {
            this.checkList.push(res.info.StrPolitical)
          }
          if (res.info.ContractJson) {
            this.ContractJson.push(JSON.parse(res.info.ContractJson))
            console.log(this.ContractJson)
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getMore(i) {
      this['showMore' + i] = !this['showMore' + i]
    },
    //计算生日 年龄 性别
    getBirth(iden) {
      let age;
      let sexnum = null;
      let sex = null;
      let myDate = new Date();
      let month = myDate.getMonth() + 1;
      var day = myDate.getDate();
      sexnum = iden.substring(16, 17);
      if (sexnum % 2 === 0) {
        sex = "女";
      } else {
        sex = "男";
      }
      age = myDate.getFullYear() - iden.substring(6, 10) - 1;
      if (
        iden.substring(10, 12) < month ||
        (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)
      )
        age++;
      var birth = iden.substring(6, 10) + "-" + iden.substring(10, 12);
      this.age = age;
      this.birth = birth;
      this.sex = sex;
    },
    backHandle() {
      window.close()
    },
    printHandel() {
      this.showPrint = true;
    },
    printClick(id) {
      const style = '.page {margin:0 10mm};' //打印时去掉眉页眉尾
      setTimeout(function () {
        printJS({
          printable: id, // 标签元素id
          type: 'html',
          targetStyles: ['*'],
          style: `table{border-collapse:separate}`
        });
      }, 500)
    },
  }
}
</script>

<style lang="scss" scoped>
.ftabs {
  background: #fff;
  padding: 0px 16px 16px;
  margin-bottom: 16px;
}

.dtlBox {
  padding-top: 8px;
}

.Reititle {
  font-size: 16px;
  font-weight: bold;
}

.titleLine {
  font-size: 20px;
  color: #F59A23;
  margin-right: 3px;
}

.btn_box {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.tabBox {
  background: #fff;
  padding: 30px;
  width: 900px;
}

.tabtop13 td {
  background-color: #ffffff;
  height: 30px;
  line-height: 150%;
}

.font-center {
  text-align: center;
  font-size: 16px;
  padding: 3px 0;
}

.titfont {
  font-family: 微软雅黑;
  font-weight: bold;
}

.printBox table {
  border: #000 2px solid;
  border-collapse: collapse;
}

table td,
table th {
  border: #000 1px solid;
  height: 25px;
}

.checkBox {
  justify-content: center;
}

.ensure {
  padding-left: 2em;
  font-size: 16px;
  color: #000;
  padding-top: 5px;
}

.d1 {
  font-size: 16px;
  color: #000;
  padding-top: 5px;
  padding-left: 10px;
  margin-bottom: 30px;
}

.d2 {
  font-size: 16px;
  color: #000;
  padding: 10px 30px 5px 5px;
}

.signatureBox {
  font-size: 16px;
  justify-content: end;
  display: flex;
  margin-top: 10px;
  color: #000;
}

.signatureTips {
  margin-top: 10px;
  font-size: 14px;
  justify-content: end;
  display: flex;
  color: #000;
}

.year {
  margin-left: 50px;
}

.photoBox {
  text-align: center;
  font-size: 18px;
}
</style>
<style>
.page_rosterEmpDtl .eleTabBtn .el-button--text {
  color: #19bd92;
  font-size: 13px;
  padding: 0;
}

.page_rosterEmpDtl .doc_table .el-table__body td.el-table__cell {
  padding: 5px 0;
}

.page_rosterEmpDtl .doc_table .el-table__body th.el-table__cell {
  padding: 8px 0;
}

.page_rosterEmpDtl .el-input__icon {
  height: 32px;
  line-height: 32px;
}

.page_rosterEmpDtl .el-input-group__append,
.el-input-group__prepend {
  padding: 0 10px;
  background: #fff;
}

.page_rosterEmpDtl .declareForm .el-form-item {
  margin-bottom: 10px;
}

.page_rosterEmpDtl .declareForm .el-form-item__error {
  top: 34px;
}

/* el-table表格固定列el-table__fixed导致滚动条无法拖动 */
.page_rosterEmpDtl .el-table__fixed {
  height: calc(100% - 18px) !important;
}

/* 用于消除固定列下方的伪元素边框线 */
.page_rosterEmpDtl .el-table__fixed:before {
  height: 0px;
}

.page_rosterEmpDtl .el-form--inline .el-form-item__content {
  width: 150px;
}

.long .el-form-item__content {
  min-width: 1000px !important;
}

.dtlItem .el-form-item {
  margin-bottom: 0px;
}

.page_rosterEmpDtl .checkBox .el-checkbox__label {
  font-size: 16px;
}

.page_rosterEmpDtl .checkBox .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #000 !important;
}

.page_rosterEmpDtl .checkBox .el-checkbox__input.is-checked .el-checkbox__inner,
.page_rosterEmpDtl .checkBox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #000 !important;
  border-color: #000 !important;
}
</style>